// extracted by mini-css-extract-plugin
export default {"listagem_titulo":"home_listagem_titulo__DIo3I","listagem_subtitulo":"home_listagem_subtitulo__ykkq4","paragrafo":"home_paragrafo__hkYVq","BannerInt":"home_BannerInt__BfqVh"};